import React, { useState, useEffect, memo } from "react";
import axios from "axios";
import { END_POINT } from "../../../constants/defaultValues";
import IntlMessages from "../../../helpers/IntlMessages";
import AddWarehouseImport from "./AddWarehouseImport";
import CameraImportModal from "./CameraImportModal";

const AddWarehouseImportModalWrapper = ({ isOpen, toggle, onSuccess }) => {
  const [dataStocks, setDataStocks] = useState([]);
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [incomingScannedItems, setIncomingScannedItems] = useState(null);

  useEffect(() => {
    if (!isOpen) return;

    const token = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT}/stock/all-unit`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.data?.data) {
          setDataStocks(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching stocks for AddWarehouseImportModalWrapper:", err);
      });
  }, [isOpen]);

  const handleSuccess = () => {
    if (onSuccess) {
      onSuccess();
    }
    window.dispatchEvent(new CustomEvent("refresh-warehouse-import-list"));
    window.dispatchEvent(new CustomEvent("refresh-stock-list"));
    toggle();
  };

  const handleOpenScanner = () => {
    setIsScannerOpen(true);
  };

  const handleScannerToggle = () => {
    setIsScannerOpen(false);
  };

  const handleApplyScannedItems = (scannedItems, meta) => {
    const defaultProvider =
      meta?.providerName && meta.providerName !== "Nhập nhanh qua Camera AI"
        ? meta.providerName
        : "";
    const enriched = (scannedItems || []).map((it) => ({
      ...it,
      provider_name: it.provider_name ?? defaultProvider,
      expiry_date: it.expiry_date || meta?.expiryDate || "",
    }));
    setIncomingScannedItems(enriched);
    setIsScannerOpen(false);
  };

  return (
    <>
      <AddWarehouseImport
        title={<IntlMessages id="warehouse.add-new-modal-title" />}
        isOpen={isOpen && !isScannerOpen}
        toggle={toggle}
        data_stocks={dataStocks}
        onSuccess={handleSuccess}
        onOpenScanner={handleOpenScanner}
        incomingScannedItems={incomingScannedItems}
        onClearIncomingScannedItems={() => setIncomingScannedItems(null)}
      />
      {isScannerOpen && (
        <CameraImportModal
          isOpen={isScannerOpen}
          applyOnly
          toggle={handleScannerToggle}
          onSuccess={handleSuccess}
          onApplyItems={handleApplyScannedItems}
        />
      )}
    </>
  );
};

export default memo(AddWarehouseImportModalWrapper);
